
export default {
    install(Vue) {
        Vue.component('debugInfo', this)
    },
    template: ''
}
